/**
 *  Guía de tallas (snippets/guia-tallas.liquid)
 *
 *  Renders the size table from the metaobject JSON and suggests a size from
 *  the customer's measurements. The link that opens it lives in the variant
 *  picker (data-lg-open="#GuiaTallas-<id>"), so opening is handled with a
 *  delegated listener: it keeps working after the picker is re-rendered.
 */
(function () {
  if (window.guiaTallasReady) return;
  window.guiaTallasReady = true;

  var MEDIDAS = ['busto', 'cintura', 'cadera'];
  var ETIQUETAS = { busto: 'Busto', cintura: 'Cintura', cadera: 'Cadera' };

  function rango(v) { return Array.isArray(v) ? v : [v, v]; }
  function formato(v) { return Array.isArray(v) ? v[0] + '-' + v[1] : v; }
  function escapar(v) {
    return String(v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function columnas(tabla) {
    return MEDIDAS.filter(function (m) { return tabla.some(function (f) { return f[m] != null; }); });
  }

  function init(root) {
    if (root.dataset.lgReady) return;
    root.dataset.lgReady = '1';

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-lg-data]').textContent) || {};
    } catch (e) {
      data = {};
    }
    var tablaEl = root.querySelector('[data-lg-table]');
    var resultado = root.querySelector('[data-lg-result]');
    var tabs = root.querySelectorAll('[data-lg-tab]');
    var tipo = data.letra ? 'letra' : 'numerica';

    tabs.forEach(function (t) {
      if (!data[t.dataset.lgTab]) t.hidden = true;
      t.addEventListener('click', function () { tipo = t.dataset.lgTab; render(); });
    });

    function render() {
      var tabla = data[tipo] || [];
      var cols = columnas(tabla);
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.lgTab === tipo); });

      var html = '<thead><tr><th>Talla</th>' + cols.map(function (c) { return '<th>' + ETIQUETAS[c] + '</th>'; }).join('') + '</tr></thead><tbody>';
      tabla.forEach(function (f, i) {
        html += '<tr data-i="' + i + '"><td>' + escapar(f.talla) + '</td>' + cols.map(function (c) { return '<td>' + (f[c] != null ? escapar(formato(f[c])) : '-') + '</td>'; }).join('') + '</tr>';
      });
      tablaEl.innerHTML = html + '</tbody>';

      // Only show the inputs the active table has
      root.querySelectorAll('[data-lg-field]').forEach(function (el) { el.hidden = cols.indexOf(el.dataset.lgField) === -1; });
      resultado.textContent = '';
    }

    function calcular() {
      var tabla = data[tipo] || [];
      var cols = columnas(tabla);
      var entrada = {};
      cols.forEach(function (m) {
        var v = parseFloat(String(root.querySelector('[name="lg-' + m + '"]').value).replace(',', '.'));
        if (!isNaN(v) && v > 0) entrada[m] = v;
      });
      if (!tabla.length || !Object.keys(entrada).length) {
        resultado.textContent = 'Ingresa al menos una medida para calcular tu talla.';
        return;
      }

      // Total distance to each size: 0 when the measurement is inside the range.
      // Ties go to the larger size.
      var mejor = -1, mejorD = Infinity;
      tabla.forEach(function (f, i) {
        var d = 0;
        for (var m in entrada) {
          if (f[m] == null) continue;
          var r = rango(f[m]), x = entrada[m];
          d += x < r[0] ? r[0] - x : x > r[1] ? x - r[1] : 0;
        }
        if (d <= mejorD) { mejorD = d; mejor = i; }
      });

      tablaEl.querySelectorAll('tbody tr').forEach(function (tr) { tr.classList.toggle('is-match', +tr.dataset.i === mejor); });
      var talla = escapar(tabla[mejor].talla);
      resultado.innerHTML = mejorD === 0
        ? 'Tu talla sugerida es <strong>' + talla + '</strong>.'
        : 'Tu talla más cercana es <strong>' + talla + '</strong>. Si estás entre dos tallas, te recomendamos la mayor.';
    }

    var modal = root.querySelector('.lg-modal');
    root.querySelector('[data-lg-close]').addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    root.querySelector('[data-lg-calc]').addEventListener('click', calcular);
    root.querySelectorAll('.lg-field input').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          calcular();
        }
      });
    });

    render();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lg-open]');
    if (!trigger) return;
    var root = document.querySelector(trigger.dataset.lgOpen);
    if (!root) return;
    e.preventDefault();
    init(root);
    root.querySelector('.lg-modal').showModal();
  });
})();
